
type StarRatingProps = {
   averageRating: number;
   className?: string; // Renamed "class" to "className" to match React's convention
};

// const StarRating: React.FC<StarRatingProps> = ({ averageRating, className }) => {
//    // console.log("averageRating: ", averageRating);

//    return (
//       <div className={`star-rating ${className}`}>

//          {Array.from({ length: averageRating }).map((_, index) => {
//             // const isChecked = index < Math.ceil(averageRating);
//             return (
//                <>
//                   {
//                      averageRating >= 1 ?
//                         <>
//                            <input value={averageRating} name="rating" id={`rating-${index}`} type="radio" />
//                            <label title={averageRating?.toFixed(2).toString()} htmlFor="star5"></label>
//                         </>
//                         :
//                         "No Ratings"
//                   }

//                </>
//             );
//          })}
//       </div>

//    )
// };


const StarRating: React.FC<StarRatingProps> = ({ averageRating, className }) => {
   return (
      <div className={`star-rating ${className}`}>
         {Array.from({ length: 5 }).map((_, index) => (
            <span key={index} style={{ color: index < averageRating ? "#ffa723" : "#666", fontSize: "20px" }} >
               ★
            </span>
         ))}
      </div>
   );
};

export default StarRating;